import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { BreadCrumb } from "../../components/breadcrumb/index";
import { InputCustomData } from "../../components/inputs/inputs";
import Title from "../../components/title/index";
import { Api } from "../../providers/index";
import { NumberFormatBr } from "../../utils/mask";
import { ModalConfirm } from "./../../components/modal/index";
import styles from "./styles.module.scss";

const ServicoProfissionalEdit = () => {
    const search = useLocation().search;
    const idQuery = new URLSearchParams(search).get("id");
    const idService = new URLSearchParams(search).get("servico");
    const [service, setService] = useState({});
    const [value, setValue] = useState(0);
    const [valueError, setValueError] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openModalActive, setOpenModalActive] = useState(false);
    const [active, setActive] = useState(false);

    useEffect(() => {
        let mounted = true;
        Api.get(`/profissional/${idQuery}/servico/${idService}`).then((res) => {
            if (res.status === 200) {
                if (mounted) {
                    setService(res.data);
                    setActive(res.data?.flagAtivo);
                    setValue(getValue(res.data));
                }
            }
        });
        return () => {
            mounted = false;
        };
    }, [idQuery, idService]);

    const isBudget = (service) => {
        return service?.servico?.tipoAgendamento === "Orçamento";
    };

    const getValue = (service) => {
        return isBudget(service) ? service?.taxaVisitaValor : service?.servicoValor;
    };

    const handleClick = (value) => {
        setOpenModal(false);
        setOpenModalActive(false);
        setTimeout(() => {
            setActive(value);
            sendForm(value);
        }, 500);
    };

    /**
     * Check Validation
     * It's true, so it's ok!
     * @returns {boolean}
     */
    const isValid = (value) => parseInt(value) > 0 && value !== "";

    const sendForm = (flagAtivo = true) => {
        let data = service;
        data.flagAtivo = flagAtivo;

        if (isBudget(data)) {
            data.taxaVisitaValor = value;
        } else {
            data.servicoValor = value;
        }

        Api.put(`profissional/${idQuery}/servico/${idService}`, data)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Profissional atualizado com Sucesso", { toastId: "success" });
                    setTimeout(() => window.location.reload(), 1000)
                }
            })
            .catch(() => {
                toast.error("Ops! Aconteceu algum problema!", { toastId: "error" });
            });
    };

    const handleSubmit = () => {
        sendForm();
    };

    const checkButtonSubmit = () => (Number(getValue(service)) !== Number(value)) && Number(value) > 0 && Number(value) < 10000;

    return (
        <>
            <Grid className="justify-content-center">
                <BreadCrumb
                    data={{
                        category: "",
                        page: "Profissional",
                        menu: {
                            item: "Usuários",
                            link: "",
                        },
                    }}
                />
                <Title title="Editar serviço do profissional" />
                <div className={styles.containerEdit}>
                    <div className={styles.containerGeralInput}>
                        <div className={styles.containerInput}>
                            <div>
                                <span>Serviço</span>
                                <InputCustomData
                                    id="servico"
                                    name="servico"
                                    value={service?.servico?.nome}
                                    fullWidth
                                    disabled
                                    backgroundColor="#ECEDEE"
                                />
                            </div>
                        </div>
                        <div className={styles.containerInput}>
                            <div>
                                <span>{isBudget(service) ? "Valor da taxa de visita" : "Valor da diária"}</span>
                                <InputCustomData
                                    value={value}
                                    required={true}
                                    onChange={(e) => {
                                        setValue(e.target.value);
                                        isValid(e.target.value)
                                            ? setValueError(false)
                                            : setValueError(true);
                                    }}
                                    InputProps={{ inputComponent: NumberFormatBr }}
                                />
                                {valueError && (<span>Campo obrigatório! mínimo aceito R$ 1,00.</span>)}
                            </div>
                        </div>
                    </div>
                    <div className={styles.containerInfoButton}>
                        <div className={styles.containerButtonEdit}>
                            {active ? (
                                <div
                                    onClick={() => setOpenModal(!openModal)}
                                >
                                    <span>Desativar serviço</span>
                                </div>
                            ) : (
                                <div
                                    onClick={() => setOpenModalActive(!openModalActive)}
                                >
                                    <span>Ativar serviço</span>
                                </div>
                            )}
                            <button
                                className={
                                    !checkButtonSubmit()
                                        ? styles.buttonSearchBlock
                                        : styles.buttonSearch
                                }
                                type="button"
                                onClick={handleSubmit}
                                disabled={!checkButtonSubmit()}
                            >
                                <span>Salvar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Grid>
            <ModalConfirm
                labelXSair="nao"
                title="Desativar Serviço"
                description="Tem certeza que deseja desativar este serviço?"
                openModal={openModal}
                setOpenModal={setOpenModal}
                onClick={() => handleClick(false)}
                labelConfirm="Desativar"
            />
            <ModalConfirm
                labelXSair="nao"
                title="Ativar Serviço"
                description="Tem certeza que deseja ativar este serviço?"
                openModal={openModalActive}
                setOpenModal={setOpenModalActive}
                onClick={() => handleClick(true)}
                labelConfirm="Ativar"
            />
        </>
    );
};

export default ServicoProfissionalEdit;